export default {
  ACCESSDRAFTS: (state: IDraftState) => {
    return state.drafts
  },
};
